<template>
  <AiEducationLayout :menu-items="menuItems">
    <EducationPageHeader title="我的课程" description="仅显示当前学生工作台授权范围内的课程" />
    <ContentWrap>
      <EducationState v-if="state === 'loading'" state="loading" title="正在加载课程" />
      <EducationState
        v-else-if="state === 'error'"
        state="error"
        title="课程加载失败"
        @retry="load"
      />
      <EducationState
        v-else-if="!courses.length"
        state="empty"
        title="暂无课程"
        description="当前账号暂无可学习课程，请联系学校或教师确认课程授权。"
      />
      <el-row v-else :gutter="16">
        <el-col v-for="course in courses" :key="course.id" :xs="24" :sm="12" :lg="8">
          <el-card class="course-card" shadow="hover" @click="openCourse(course.id)">
            <h3>{{ course.name || '未命名课程' }}</h3>
            <p>{{ course.subtitle || course.description || '暂无课程简介' }}</p>
            <el-button link type="primary">查看课程详情</el-button>
          </el-card>
        </el-col>
      </el-row>
    </ContentWrap>
  </AiEducationLayout>
</template>

<script setup lang="ts">
import AiEducationLayout from '../layout/AiEducationLayout.vue'
import type { EducationMenuItem } from '../layout/types'
import EducationPageHeader from '../components/EducationPageHeader.vue'
import EducationState from '../components/EducationState.vue'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { getMyStudentCoursePage, type StudentCourseVO } from '@/api/aiEducation'

defineOptions({ name: 'AiEducationStudentCourses' })
const menuItems: EducationMenuItem[] = [
  {
    title: '学习首页',
    path: '/ai-Application-center/ai-education/student/home',
    icon: 'ep:home-filled'
  },
  {
    title: '我的课程',
    path: '/ai-Application-center/ai-education/student/courses',
    icon: 'ep:reading'
  },
  {
    title: '我的作业',
    path: '/ai-Application-center/ai-education/student/assignments',
    icon: 'ep:document-checked'
  },
  {
    title: 'AI 学伴',
    path: '/ai-Application-center/ai-education/student/assistant',
    icon: 'ep:magic-stick'
  }
]
const router = useRouter()
const courses = ref<StudentCourseVO[]>([])
const state = ref<'loading' | 'ready' | 'error'>('loading')
const load = async () => {
  state.value = 'loading'
  try {
    courses.value = (await getMyStudentCoursePage()).list || []
    state.value = 'ready'
  } catch {
    state.value = 'error'
  }
}
const openCourse = (id: number) =>
  router.push(`/ai-Application-center/ai-education/student/courses/${id}`)
onMounted(load)
</script>

<style scoped>
.course-card {
  min-height: 150px;
  margin-bottom: 16px;
  cursor: pointer;
}
.course-card h3 {
  margin: 0 0 10px;
  color: #17222d;
}
.course-card p {
  min-height: 42px;
  color: #697681;
  line-height: 1.6;
}
</style>
